import { Checkbox } from 'components/tailwind-ui/Checkbox';
import * as React from 'react';
import { Customer } from 'types/Customer';

interface Props {
  reference: Customer;
  onChange: (reference: Customer, checked: boolean) => void;
  checked: boolean;
}

export const Reference: React.FC<Props> = (props) => {
  const { reference, onChange, checked } = props;
  return (
    <Checkbox
      id={`reference-filter-${reference.code}`}
      onCheck={(c) => onChange(reference, c)}
      checked={checked}
      className="px-3 py-2 hover:bg-blue-200"
      label={
        <div>
          {reference.code} ({reference.count} containers)
        </div>
      }
    />
  );
};
Reference.displayName = 'Shipments.Components.ReferenceFilter.Reference';
